import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=18bf056c&scoped=true&"
import script from "./Gauge.vue?vue&type=script&lang=js&"
export * from "./Gauge.vue?vue&type=script&lang=js&"
import style0 from "./Gauge.vue?vue&type=style&index=0&id=18bf056c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf056c",
  null
  
)

export default component.exports